// extracted by mini-css-extract-plugin
export default {"locationButton_card__label__d4cTJ":"loading_locationButton_card__label__d4cTJ__BDTNP","loading":"loading_loading__ny3AW","label":"loading_label__F-+F5"};